/**
 * 361 Sleep — Section 12
 * Soft staggered reveal for lifestyle cards
 */
(function () {
  'use strict';

  var BOOTED = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenGsap(fn) {
    if (window.gsap && window.ScrollTrigger) {
      fn(window.gsap, window.ScrollTrigger);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.gsap && window.ScrollTrigger) {
        clearInterval(timer);
        fn(window.gsap, window.ScrollTrigger);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initSection(section, gsap, ScrollTrigger) {
    var cards = section.querySelectorAll('[data-moments-card]');
    var head = section.querySelector('.moments361__head');
    if (!cards.length) return;

    if (section._moments361Ctx) {
      section._moments361Ctx.revert();
      section._moments361Ctx = null;
    }

    var ctx = gsap.context(function () {
      var mm = gsap.matchMedia();

      mm.add('(prefers-reduced-motion: reduce)', function () {
        gsap.set([head, cards], { clearProps: 'all' });
      });

      mm.add('(prefers-reduced-motion: no-preference)', function () {
        if (head) {
          gsap.from(head, {
            opacity: 0,
            y: 28,
            duration: 0.75,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: section,
              start: 'top 78%',
              toggleActions: 'play none none none'
            }
          });
        }

        gsap.from(cards, {
          opacity: 0,
          y: 36,
          duration: 0.7,
          ease: 'power2.out',
          stagger: 0.12,
          scrollTrigger: {
            trigger: section.querySelector('.moments361__grid') || section,
            start: 'top 82%',
            toggleActions: 'play none none none'
          }
        });
      });
    }, section);

    section._moments361Ctx = ctx;
  }

  function boot() {
    whenGsap(function (gsap, ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      document.querySelectorAll('[data-moments361]').forEach(function (section) {
        initSection(section, gsap, ScrollTrigger);
      });
      if (!BOOTED) {
        BOOTED = true;
        window.addEventListener(
          'load',
          function () {
            ScrollTrigger.refresh();
          },
          { once: true }
        );
      }
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    if (!root.querySelector('[data-moments361]') && !(root.matches && root.matches('[data-moments361]'))) {
      return;
    }
    boot();
  });
})();
